import { ColumnSort, Identifiable } from 'shared/types'

export type TableState = {
  size: number
  page: number
  sort: ColumnSort[]
  selected: string[]
  selectedData: any[],
  search: string
}

export const tableInitialState: TableState = {
  size: 10,
  page: 0,
  sort: [],
  selected: [],
  selectedData:  [],
  search: '',
}

export type RowSelectionPayload<T extends Identifiable> = {
  index: number
  checked: boolean
  rows: T[]
}

export default function tableReducer<T extends Identifiable>(state: TableState, action: TableAction<T>): TableState {
  if (action.type === 'SetSearch') {
    return {
      ...tableInitialState,
      search: action.payload,
      sort: state.sort,
    }
  }
  if (action.type === 'ResetSelected') {
    return { ...state, selected: [] }
  } else if (action.type === 'SetSort') {
    if (!action?.payload?.column)
      return state

    return { ...state, sort: [action.payload] }
  }
  const keyMappings = {
    SetSize: 'size',
    SetPage: 'page',
    SetSelected: 'selected',
  }
  const key = keyMappings[action.type]
  if (action.type === 'SetSelected') {
    const { index, checked, rows } = action.payload
    const { selected, selectedData } = state
    let arr = []
    let selectedArr: any = []

    if (index === 0) {
      arr = checked ? rows.map(e => e.id) : []
      selectedArr = checked ? rows : []
    } else {
      const { id } = rows[index - 1]
      arr = checked ? [...selected, id] : selected.filter(e => e !== id)
      selectedArr = checked ? [...selectedData, rows[index - 1]] : selectedData.filter((e: any) => e.id !== id)
    }
    return { ...state, [key]: arr, selectedData: selectedArr }
  }
  return { ...state, [key]: action.payload }
}

export type TableAction<T extends Identifiable> =
  | { type: 'SetSize'; payload: number }
  | { type: 'SetPage'; payload: number }
  | { type: 'SetSort'; payload: ColumnSort }
  | { type: 'SetSelected'; payload: RowSelectionPayload<T> }
  | { type: 'ResetSelected' }
  | { type: 'SetSearch'; payload: string }
